/**
 * 🤖 AUTO-GENERATED FILE - DO NOT EDIT!
 *
 * Generated by vite-plugins/prodeng-routes.ts
 * Source: content/prodeng/2026-01-06_the-cost-of-certainty.md
 */

import { createFileRoute } from '@tanstack/react-router';
import { ProdEngArticleLayout } from '@/components/ProdEngArticleLayout';
import { createArticleMeta } from '@/lib/meta';
import Content from '@/content/prodeng/the-cost-of-certainty.mdx';

const metadata = {
  title: "The Cost of Certainty (and Why the Best Teams Avoid It)",
  date: "2026-01-06",
  author: "Christian Battaglia",
  articleNumber: 3,
  seoDescription: "Certainty feels like rigor but eliminating uncertainty is a false optimization. Learn why strong teams absorb uncertainty rather than fight it, and how weak systems respond to unpredictability.",
  linkedinUrl: "https://www.linkedin.com/pulse/cost-certainty-why-best-teams-avoid-christian-battaglia-oze1e",
  heroImage: "/prodeng/the-cost-of-certainty.webp",
  readTime: "5 min read",
  tags: ["product engineering","uncertainty","certainty","product management","engineering culture","software engineering","decision-making","risk"],
  published: true,
};

export const Route = createFileRoute('/prodeng/articles/the-cost-of-certainty')({
  component: ArticlePage,
  head: () => createArticleMeta({
    title: `${metadata.title} — Product Engineering`,
    description: metadata.seoDescription || '',
    path: '/prodeng/articles/the-cost-of-certainty',
    image: '/og/prodeng/the-cost-of-certainty.png',
    imageAlt: metadata.title,
    datePublished: metadata.date,
    authorName: metadata.author,
    readTime: metadata.readTime,
    tags: metadata.tags,
    section: 'Product Engineering',
  }),
});

function ArticlePage() {
  return (
    <ProdEngArticleLayout {...metadata}>
      <Content />
    </ProdEngArticleLayout>
  );
}
